import { TableContainer } from "../../styles";
import { BoxComFaixa, FaixaTitulo, TableContainerEstiloExemplo } from "./styles";

export interface CampoValor {
  campo: string;
  valor: string;
}

interface BlocoPrincipalProps {
  campos: CampoValor[];
  sectionTitle?: string;
  tituloComoFaixa?: boolean;
}

export default function BlocoPrincipal({ campos, sectionTitle = "Principal", tituloComoFaixa = false }: BlocoPrincipalProps) {
  if (campos.length === 0) {
    return null;
  }

  const tabela = (
    <TableContainerEstiloExemplo>
      <table className="data-table">
        <thead>
          <tr>
            <th className="field-col">Campo</th>
            <th className="value-col">Valor</th>
          </tr>
        </thead>
        <tbody>
          {campos.map((campo, i) => (
            <tr key={i} className={i > 0 ? 'border-top' : ''}>
              <td className="field-cell">{campo.campo}</td>
              <td className={`value-cell ${campo.valor === '—' ? 'empty-value' : ''}`}>
                {campo.valor}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableContainerEstiloExemplo>
  );

  if (tituloComoFaixa) {
    return (
      <BoxComFaixa className="expanded-section">
        <FaixaTitulo>{sectionTitle}</FaixaTitulo>
        {tabela}
      </BoxComFaixa>
    );
  }

  return (
    <div className="expanded-section">
      <h4 className="section-title">{sectionTitle}</h4>
      <TableContainer>
        <table className="data-table">
          <thead>
            <tr>
              <th className="field-col">Campo</th>
              <th className="value-col">Valor</th>
            </tr>
          </thead>
          <tbody>
            {campos.map((campo, i) => (
              <tr key={i} className={i > 0 ? 'border-top' : ''}>
                <td className="field-cell">{campo.campo}</td>
                <td className={`value-cell ${campo.valor === '—' ? 'empty-value' : ''}`}>
                  {campo.valor}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </TableContainer>
    </div>
  );
}
